import React from "react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
export function FinalCta() {
  return <section className="bg-ink px-4 py-16 sm:px-6 sm:py-24" data-id="element-158" data-mp="22cksoz4pane3">
      <div className="mx-auto max-w-3xl text-center" data-id="element-159" data-mp="1nphroih65wm0">
        <h2 className="font-display text-[30px] font-black leading-[1.1] tracking-tight text-white sm:text-5xl" data-id="element-160" data-mp="1nopytfeyiczf">
          Ready to Bring More Structure to Your Musculoskeletal Assessments?
        </h2>
        <div className="mt-6 space-y-4 text-lg leading-relaxed text-white/80" data-id="element-161" data-mp="1eqe7tca6hd6g">
          <p data-id="element-162" data-mp="1irgak33b07d6">
            You don’t need to memorize every assessment framework or keep every reference scattered across different documents.
          </p>
          <p data-id="element-163" data-mp="19oov7s7b4rg9">
            You can build a more organized approach to gathering information, reviewing warning signs, and developing your
            clinical reasoning.
          </p>
          <p data-id="element-164" data-mp="3437wjrg44owp">I’ve brought these educational resources together into one collection so you can review them at your own pace.</p>
        </div>

        <div className="-mx-4 mt-10 bg-white py-6 sm:mx-0 sm:rounded-3xl" data-id="element-165" data-mp="283ah0qxxyt1">
          <img src={images.mockup} alt="Musculoskeletal Clinical Pathway collection" className="mx-auto w-full max-w-xl" loading="lazy" data-id="element-166" data-mp="3tfxvoykq9urf" />
        </div>

        <p className="mt-10 font-display text-lg font-bold uppercase tracking-wide text-white" data-id="element-167" data-mp="b0n8q03bm1dc">
          Get Musculoskeletal Clinical Pathway™ today
        </p>
        <p className="mt-1 text-base text-white/75" data-id="element-168" data-mp="3fevasp5gyqi3">6 Comprehensive Volumes + 5 Specialized Bonuses</p>
        <p className="mt-4 font-display text-2xl font-black uppercase text-[#FDBA74]" data-id="element-169" data-mp="3ahlmxdxqamwd">Only</p>
        <p className="font-display text-[88px] font-black leading-none text-white sm:text-[112px]" data-id="element-170" data-mp="3ogl7a9e7kfmq">$27</p>

        <div className="mt-8" data-id="element-171" data-mp="3jg6y2o0vezn4">
          <CtaButton size="xl" label="Yes! Give Me Access to the Complete Pathway" data-id="element-172" data-mp="3jfxblaf1bam6" />
        </div>
        <p className="mt-4 text-sm font-medium text-white/75" data-id="element-173" data-mp="13o9glkjkzs60">
          One-time payment · Instant digital access · Lifetime access to your purchased files · 7-day money-back guarantee
        </p>
      </div>
    </section>;
}